import useHomeStore, {
  IDivinationResponse,
  IJsApiConfigRequestData,
  IJsApiConfigResponseData,
} from "@/store/HomeStore";
import { Toast } from "vant";
import router from "@/router";
import { HomePage } from "@/config";
import { RouteParamsRaw } from "vue-router";
// @ts-ignore
import wx from "weixin-js-sdk";
import { getImageUrl } from "@/utils/index";

/**
 * 微信下单
 * @param orderType 0 问一问 1 起卦
 * @param questionInfo IDivinationResponse 对象主要传入questionId
 * @param fromPage 来自哪个页面
 * @param toPage string|去哪个页面,对应路由中的名称 DivinationAIResult(起卦) | function
 */
export const pay = async (
  orderType: 0 | 1,
  questionInfo: IDivinationResponse | null = null,
  fromPage: string = "",
  toPage: string | Function | null = null
): Promise<void | Record<string, any>> => {
  if (!questionInfo || !questionInfo.questionId) {
    await router.push(HomePage);
    return;
  }
  if (import.meta.env.DEV) {
    if (toPage) {
      if (typeof toPage === "string") {
        await router.push({
          name: toPage,
          params: {
            orderNo: "N202208261708537697816",
            questionId: 5,
            from: fromPage,
          } as RouteParamsRaw,
        });
      } else if (typeof toPage === "function") {
        toPage({ success: true });
      } else {
        Toast("支付成功");
      }
    } else {
      return Promise.resolve({ success: true });
    }
  } else {
    const homeStore = useHomeStore();
    const res = await homeStore.order({
      questionId: questionInfo.questionId,
      orderType,
    });
    const { wxpayQequestData, orderNo, questionId } = res;
    window.WeixinJSBridge.invoke(
      "getBrandWCPayRequest",
      wxpayQequestData,
      (payRes: Record<string, any>) => {
        if (payRes.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          if (toPage) {
            if (typeof toPage === "string") {
              router.push({
                name: toPage,
                params: {
                  orderNo,
                  questionId,
                  from: fromPage,
                } as RouteParamsRaw,
              });
            } else if (typeof toPage === "function") {
              toPage({ ...payRes, success: true });
            } else {
              Toast("支付成功");
              return Promise.resolve({ ...payRes, success: true });
            }
          } else {
            Toast("支付成功");
            return Promise.resolve({ ...payRes, success: true });
          }
        } else {
          Toast("支付失败");
          return Promise.resolve({ ...payRes, success: false });
        }
      }
    );
  }
};

export const wxConfig = (data: Record<string, any>, callback?: () => void) => {
  wx.config({
    debug: false,
    // 后台返回之前获取的appId
    appId: data.appId,
    // 必填，生成签名的时间戳
    timestamp: data.timestamp,
    // 必填，生成签名的随机串
    nonceStr: data.nonceStr,
    // 必填，签名，见附录1
    signature: data.signature,
    // 必填，需要使用的JS接口列表，所有JS接口列表见附录3
    jsApiList: [
      "onMenuShareTimeline", //1.0分享到朋友圈
      "onMenuShareAppMessage", //1.0 分享到朋友
      "updateAppMessageShareData", //1.4 分享到朋友
      "updateTimelineShareData", //1.4分享到朋友圈
      // "chooseImage", //拍照或从手机相册中选图接口
      // "previewImage", //预览图片接口
      // "uploadImage", //上传图片接口
      // "downloadImage", //下载图片接口
      // "getLocalImgData", //获取本地图片接口
    ],
  });
  callback && callback();
};

export const wxInit = async (href: string = ""): Promise<void> => {
  const homeStore = useHomeStore();
  const res = await homeStore.getJsApiConfig({
    url: encodeURIComponent(location.href),
  });
  const { appId, timestamp, nonceStr, signature } = res;
  wxConfig({
    appId: appId,
    timestamp: timestamp,
    nonceStr: nonceStr,
    signature: signature,
  });
  let shareHref = href || window.location.href;
  //console.log("🐯", "[shareHref]", shareHref);
  wx.ready(() => {
    wx.checkJsApi({
      jsApiList: [
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "updateAppMessageShareData",
        "updateTimelineShareData",
      ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success: function (res: any) {
        // 以键值对的形式返回，可用的api值true，不可用为false
        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        console.log("checkJsApi=>", res);
      },
    });

    const commonShareData = {
      // 分享标题
      title: "满意度超过90%的测算软件",
      // 分享描述
      desc: "解惑安心，指点迷津。每天免费一次！@大简易经",
      // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      link: shareHref,
      // 分享图标
      // imgUrl: getImageUrl('../assets/images/logo.png'),
      imgUrl: getImageUrl("../assets/images/share/logo.jpg"),
      success: function () {
        //console.log("分享回调函数");
      },
    };
    wx.updateTimelineShareData(commonShareData); //1.4
    wx.updateAppMessageShareData(commonShareData); //1.4
    wx.onMenuShareTimeline(commonShareData); //1.0
    wx.onMenuShareAppMessage(commonShareData); //1.0
  });
  wx.error((err: string) => {
    console.log("🐯", "[wx_err]", err);
  });
};
